module.exports = __webpack_public_path__ + "img/today-tip-bg.576ab992.png";